import { render } from "./VendorServicesTable.vue?vue&type=template&id=6bf0058e"
import script from "./VendorServicesTable.vue?vue&type=script&lang=ts"
export * from "./VendorServicesTable.vue?vue&type=script&lang=ts"

import "./VendorServicesTable.vue?vue&type=style&index=0&id=6bf0058e&lang=scss"
script.render = render

export default script